import React, {useEffect, useRef} from 'react';
import "./ProCommodity.scss"
import {Col, Collapse, Layout, Row} from "antd";
import {Content} from "antd/es/layout/layout";
import {
    TLayoutStyle2,
    TLayoutStyle2Reversed,
    TLayoutMobile
} from "../ProSubscription/ProTLayout";
import section_background_1 from "../ProCommodity/imgs/55inchTexturainJewelleryShop1.webp";
import section_background_2 from "../ProCommodity/imgs/55inchinOfficeLobbywithKemelyenArt2.webp";
import {MinusOutlined, PlusOutlined} from "@ant-design/icons";
import {PRODUCT_TEXT} from "../../text";
import DisplayStunningArtwork from "./imgs/DisplayStunningArtwork.webp";
import DisplayYourOwnContent from "./imgs/DisplayYourOwnContent.webp";
import ProVerticalCarousel55 from "./ProCarousel/ProVerticalCarousel55";
import useWindowResize from "../../apps/Hooks/useWindowResize";
import ContactSection from "../ProCaseStudy/components/ContactSection";
import UltraRealisticDisplay from "./imgs/ultraRealisticDisplay.webp";
import IntegratedSpeakers from "./imgs/IntegratedSpeakers.webp";
import EasyMounting from "./imgs/EasyMounting.webp";
import MultipleFrameOptions from "./imgs/MultipleFrameOptions.webp";

const {Panel} = Collapse;
const ProCommodity = (props) => {
    const {windowWidth} = useWindowResize()
    const CommoditySectionTitle1 =
        <p className={"pro-section-commodity-title"}>
            Refine Your <span style={{color: '#936846'}}> Corporate Messaging </span>
        </p>

    const CommoditySectionTitle2 =
        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-end', marginRight: '2rem'}}>
            <p className={"pro-section-commodity-title-button"} style={{textAlign: 'right'}}>
                Setting the <span style={{color: '#936846'}}> Scene </span>
            </p>
            <button
                onClick={_ => window.location.href = "/pro/software"}
                className="homeMainButton black-border-hover-white"
                style={{maxWidth: "22rem", width: '100%'}}>
                <p className={'homeMainButtonLnk homeOverV'} style={{margin: 0}}>
                    EXPLORE SOFTWARE
                </p>
            </button>
        </div>

    const CommoditySectionTitle1Mobile =
        <p className={"pro-section-commodity-title-mobile"}>
            Differentiate Your Brand with the <span style={{color: '#936846'}}> Power of Art </span>
        </p>

    const CommoditySectionTitle2Mobile =
        <div style={{display: 'flex', flexDirection: 'column', margin: '6vw'}}>
            <p className={"pro-section-commodity-title-button"} style={{margin: '0'}}>
                Elevate Your Space: <span style={{color: '#936846'}}> Inspire Creativity </span> and <span
                style={{color: '#936846'}}> Productivity </span>
            </p>
            <div style={{height: '1rem'}}></div>
            <button
                onClick={_ => window.location.href = "/pro/customer-stories"}
                className="homeMainButton black-border-hover-white"
                style={{width: '100%'}}>
                <p className={'homeMainButtonLnk homeOverV'} style={{margin: 0}}>
                    EXPLORE CUSTOMER STORIES
                </p>
            </button>
            <div style={{height: '1rem'}}></div>
        </div>

    const page1 = [
        [
            "Flexible Content Playback",
            "Textura Pro gives you total flexibility for displaying content your way. " +
            "Manage and schedule artwork directly via the Vieunite Pro Portal, run third-party apps on the integrated Android 14 media player, " +
            "or connect an external device via HDMI.", "link"],
        [
            "Remarkable 4K Resolution",
            "Stunning 4K visuals offer ultra-high definition clarity, showcasing every intricate detail with vivid detail. " +
            "Ideal for displaying art, photography, or video content, bringing every image to life with true cinematic quality.", "link"],
    ];
    const page2 = [
        [
            "Curated Collections & Art Library",
            "Unlock a world of inspiration with Textura’s vast, expertly curated art library, featuring works from emerging talent and world-renowned galleries. " +
            "Rotate collections, create personalised playlists, or bring classic and contemporary masterpieces into any space for a constantly fresh, gallery-quality experience.", "link"],
        [
            "Vieunite Pro CMS",
            "Take full control of your Textura with our advanced content management system. Easily schedule, " +
            "update, and organise content across multiple canvases through a secure, intuitive platform.", "link"],
    ];
    const specificationSections = [
        {
            title: 'Display',
            items: [
                ['Resolution (px)', '3840 x 2160 @60Hz'],
                ['Display/Active Area (mm)', '1230 x 720'],
                ['Aspect Ratio', '16:9'],
                ['Brightness', '50-350cd/m2'],
                ['Colour', '1.07 Billions (8bit + 2bit FRC); 72% NTSC'],
                ['Haze Level', '25%'],
                ['Viewing Angle (°)', '89/89/89/89'],
                ['Contrast Ratio', '5,000: 1'],
                ['Orientation Support', 'Landscape / Portrait'],
                ['Operating Hours', '24/7 Commercial Use']
            ]
        },
        {
            title: 'System & Performance',
            items: [
                ['CPU', 'RK3568 64bit Cortex-A55 Quad @2GHz'],
                ['GPU', 'Quad Mali-G52 2EE'],
                ['Graphics API Support', 'OpenGL ES 1.1/2.0/3.2, OpenCL 2.0 and Vulkan 1.1'],
                ['OS Operating System', 'Android 14'],
                ['RAM', '4GB'],
                ['Storage', '32GB'],
                ['Media Format', 'Supports FHD 60FPS H.264/H.265 video encoding'],
                ['LAN', '10/100/1000M RJ45'],
                ['Wi-Fi', 'Dual-band 2.4GHz / 5GHz (802.11a/b/g/n/ac)'],
                ['Bluetooth', '5.0']
            ]
        },
        {
            title: 'Connectivity & Interface',
            items: [
                ['HDMI', '1 x HDMI 2.0 IN'],
                ['USB', '1 × USB 3.0 Type-A; 1 x USB 2.0 Type-A; 1 x USB Type-C (OTG only)'],
                ['RS232', '1 x RJ45 (Serial Control)'],
                ['Ethernet', '1 x RJ45 (10/100/1000M)'],
                ['Audio Out', '1 x 3.5mm Audio Out'],
                ['Expansion Slot', '1 x Micro SD'],
                ['Power Input', '1 x IEC C6 (Cloverleaf)'],
                ['Switch', '1 x Power Switch'],
                ['Speakers', '2 x 5W'],
                ['4G Module (Optional)', '1 x SIM In']
            ]
        },
        {
            title: 'Power Management',
            items: [
                ['Power Supply', 'AC 100-240V, 50/60Hz'],
                ['Power Consumption', 'Typical: TBC; Max: 200W'],
                ['Standby Power', '≤0.5W']
            ]
        },
        {
            title: 'Dimensions & Weight',
            items: [
                ['Screen Dimensions (mm)', '1261 x 733.1 x 83.3'],
                ['Package Dimensions (mm)', '1390 x 870 x 230'],
                ['VESA Mounting (mm)', '400 x 400 M6 12mm'],
                ['Net Weight (Including Frame and Wall Mount)', '21.6 kg'],
                ['Gross Weight (Including Frame and Wall Mount)', '25.2 kg']
            ]
        },
        {
            title: 'Environmental Conditions',
            items: [
                ['Operating Temperature (°C)', '0 to 40°C'],
                ['Storage Temperature (°C)', '-10°C to 55°C'],
                ['Operating Relative-Humidity (%)', '10% to 80%'],
                ['Storage Relative-Humidity', '10% to 80%']
            ]
        },
        {
            title: 'Accessories',
            items: [
                ['Included Accessories', 'Real Wood Frame (Walnut or Black), 1.8m IEC C6 UK Power Lead, Remote Control, 2x AAA batteries, Wall Mount'],
                ['Optional Accessories', 'Additional Walnut Frame or Black Frame']
            ]
        },
        {
            title: 'Warranty',
            items: [
                ['Warranty Period', '3 Years (On-site)'],
                ['Technical Support', 'Lifetime']
            ]
        }
    ];
    const displayContentCards = [
        {
            title: 'Display stunning Artwork',
            image: DisplayStunningArtwork
        },
        {
            title: 'Display your own Content',
            image: DisplayYourOwnContent
        }
    ];
    const engineeredForArtistryCards = [
        {
            title: 'Ultra-Realistic Display',
            image: UltraRealisticDisplay,
            imageStyle: {
                objectPosition: 'center bottom'
            }
        },
        {
            title: 'Easy Mounting',
            image: EasyMounting,
            imageStyle: {
                objectPosition: 'center bottom'
            }
        },
        {
            title: 'Integrated Speakers',
            image: IntegratedSpeakers,
            imageStyle: {
                objectPosition: 'center bottom'
            }
        },
        {
            title: 'Multiple Frame Options',
            image: MultipleFrameOptions,
            imageStyle: {
                objectPosition: 'center bottom'
            }
        }
    ];
    const engineeredForArtistrySection =
        <div style={{margin: windowWidth > 920 ? '6.5rem 0 5rem 0' : '4rem 0 3.5rem 0'}}>
            <Row justify={"center"}>
                <Col>
                    <p
                        style={{
                            margin: 0,
                            paddingBottom: '1.5rem',
                            textAlign: 'center',
                            color: '#000',
                            fontFamily: 'Proxima Nova Regular, sans-serif',
                            fontSize: windowWidth > 920 ? '48px' : '34px',
                            lineHeight: windowWidth > 920 ? '1.1' : '1.2'
                        }}
                    >
                        Engineered for <span style={{color: '#936846'}}>Artistry</span>
                    </p>
                </Col>
            </Row>
            <Row
                gutter={[windowWidth > 920 ? 30 : 18, windowWidth > 920 ? 30 : 18]}
                justify={"center"}
                style={{
                    margin: "0 7vw"
                    // margin: windowWidth > 920 ? '2rem auto 0 auto' : '1.5rem auto 0 auto'
                }}
            >
                {engineeredForArtistryCards.map((card) => (
                    <Col key={card.title} xs={24} sm={12} lg={6} style={{display: 'flex'}}>
                        <div
                            style={{
                                position: 'relative',
                                width: '100%',
                                height: windowWidth > 920 ? '27vw' : windowWidth > 576 ? '31vw' : '44vw',
                                borderRadius: '23px',
                                overflow: 'hidden',
                                backgroundColor: '#F5F7F8'
                            }}
                        >
                            <p
                                style={{
                                    position: 'absolute',
                                    top: windowWidth > 920 ? '35px' : '24px',
                                    left: '50%',
                                    width: '100%',
                                    margin: 0,
                                    transform: 'translateX(-50%)',
                                    textAlign: 'center',
                                    color: '#000',
                                    fontFamily: 'Proxima Nova Regular, sans-serif',
                                    fontSize: '1.5rem',
                                    lineHeight: '1.15',
                                    padding: '0 1vw',
                                    zIndex: 2
                                }}
                            >
                                {card.title}
                            </p>
                            <img
                                src={card.image}
                                alt={card.title}
                                style={{
                                    position: 'absolute',
                                    inset: 0,
                                    width: '100%',
                                    height: '100%',
                                    display: 'block',
                                    objectFit: 'contain',
                                    ...card.imageStyle
                                }}
                            />
                        </div>
                    </Col>
                ))}
            </Row>
        </div>;
    const videoRef = useRef(null);
    const makeMuted = (elt) => {
        if (elt) {
            elt.muted = true;
        }
    };
    return (
        <Layout>
            <Content>
                <Row style={{margin: "0 8vw", paddingTop: "90px", display: 'flex', justifyContent: 'center', justifyItems: 'center'}}>
                    {/*<img*/}
                    {/*    src={windowWidth > 920 ? "/20251114_banner.png" : "/20251114_banner_mobile.png"} alt="activity_banner"*/}
                    {/*    style={{maxHeight: '100%', maxWidth: '100%', height: 'auto', width: 'auto', cursor: 'pointer'}}*/}
                    {/*    onClick={() => {*/}
                    {/*        window.open("https://vieunite.com/home/digital-canvas?promocode=BLACKFRIDAY100", "_blank")*/}
                    {/*    }}*/}
                    {/*/>*/}
                </Row>
                <Row justify={"center"} style={{width: '82vw', margin: '40px auto 2vh 4vw'}} //margin: '14vh auto 2vh 4vw'
                     className={'pro-commodity-carousel-outer-row'}>
                    <Col style={{width: windowWidth > 920 ? '60vw' : '80vw', height: '60vh',}}>
                        <ProVerticalCarousel55/>
                    </Col>
                    <Col style={{
                        width: windowWidth > 920 ? '20vw' : '80vw',
                        // height: '60vh',
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        alignItems: windowWidth > 920 ? 'flex-start' : "center",
                        marginTop: windowWidth > 920 ? '0' : '2rem'
                    }}>
                        <div>
                            <p className={'pro-commodity-top-p1'}>55” Textura Pro Digital Canvas</p>
                            <p className={'pro-commodity-top-p2'}>Experience art like never before with the Textura Pro’s 4K
                                resolution texture-accurate display technology bringing every brushstroke and detail to life in vivid realism.</p>
                            <p className={'pro-commodity-top-p3'}></p>
                            <ul className={'pro-commodity-top-p4'}>
                                <li>Installation is quick and effortless, with a free flush-fit wall mounting system that
                                    ensures your display is securely positioned. Supports landscape and portrait orientation.
                                </li>
                                <li>Choose from Black or Walnut premium frames to seamlessly integrate with your interior,
                                    creating a tailored look that enhances the display’s elegance.
                                </li>
                                <li>Provides complete management control through the Vieunite Pro Portal,
                                    making display management simple and fully customisable.
                                </li>
                            </ul>

                        </div>
                        <div style={{width: '100%'}}>
                            {/*<p className={'pro-commodity-top-p1'}>£619</p>*/}
                            {/*<p className={'pro-commodity-top-p3'} style={{margin: '-1vh auto 1.2vh auto'}}>£742.80 incl.*/}
                            {/*    VAT</p>*/}
                            {/*<p className={'pro-commodity-top-p2'} style={{margin: '-1vh auto 3vh auto'}}>SUBSCRIPTION*/}
                            {/*    FEES MAY APPLY</p>*/}
                            <button onClick={_ => window.location.href = "/pro/support/request-demo"}
                                    className={'pay-button'}
                                    style={{
                                        marginTop: '1em',
                                        fontFamily: "Proxima Nova Regular, sans-serif",
                                        fontWeight: '800',
                                        borderRadius: "5px",
                                        padding: '0.5em',
                                        width: '100%',
                                        cursor: 'pointer',
                                    }}
                            >
                                ENQUIRY
                            </button>
                        </div>
                    </Col>
                </Row>

                <Row
                    gutter={[24, 24]}
                    justify={"center"}
                    style={{
                        paddingTop: '8vh',
                        paddingBottom: '4vh',
                        marginLeft: '7.5vw',
                        marginRight: '7.5vw'
                    }}
                >
                    {displayContentCards.map((card) => (
                        <Col
                            key={card.title}
                            span={24}
                            lg={12}
                            md={12}
                            style={{
                                padding: '0',
                                display: 'flex',
                                justifyContent: 'center'
                            }}
                        >
                            <div
                                style={{
                                    position: 'relative',
                                    width: '100%',
                                    height: windowWidth > 920 ? '22vw' : '40vw',
                                    borderRadius: '20px',
                                    overflow: 'hidden',
                                    // backgroundColor: '#111',
                                    cursor: 'default',
                                    marginLeft: '0.5vw',
                                    marginRight: '0.5vw'
                                }}
                            >
                                <img
                                    src={card.image}
                                    alt={card.title}
                                    style={{
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'fill',
                                        display: 'block'
                                    }}
                                />
                                <div
                                    style={{
                                        position: 'absolute',
                                        inset: 0,
                                        background: 'linear-gradient(180deg, rgba(0,0,0,0.02) 45%, rgba(0,0,0,0.45) 100%)'
                                    }}
                                />
                                <p
                                    style={{
                                        position: 'absolute',
                                        left: windowWidth > 920 ? '36px' : '20px',
                                        bottom: windowWidth > 920 ? '28px' : '18px',
                                        margin: 0,
                                        color: '#FFF',
                                        fontFamily: 'Proxima Nova Regular, sans-serif',
                                        fontSize: windowWidth > 920 ? '1.5rem' : '24px',
                                        lineHeight: '1.2',
                                        maxWidth: windowWidth > 920 ? '70%' : '85%'
                                    }}
                                >
                                    {card.title}
                                </p>
                            </div>
                        </Col>
                    ))}
                </Row>

                {windowWidth > 920 ?
                    <div>
                        <TLayoutStyle2
                            HeaderSection={CommoditySectionTitle1}
                            HeaderHeight={'2rem'}
                            CardList={page1}
                            CardWidth={'50%'}
                            BackgroundImg={section_background_1}/>
                        {engineeredForArtistrySection}
                        <TLayoutStyle2Reversed
                            HeaderSection={CommoditySectionTitle2}
                            HeaderHeight={'2rem'}
                            CardList={page2}
                            CardWidth={'50%'}
                            BackgroundImg={section_background_2}
                        />
                    </div> :
                    <div>
                        <TLayoutMobile
                            HeaderSection={CommoditySectionTitle1Mobile}
                            CardList={page1}
                            BackgroundImg={section_background_1}/>
                        {engineeredForArtistrySection}
                        <TLayoutMobile
                            HeaderSection={CommoditySectionTitle2Mobile}
                            CardList={page2}
                            BackgroundImg={section_background_2}
                        />
                        {/*<div style={{height: '6rem'}}></div>*/}
                    </div>
                }

                <Row justify={"center"} style={{marginBottom: '6vh'}}>
                    <Col span={20} lg={20} md={20}>
                        <Collapse expandIconPosition={"end"}
                                  bordered={false}
                                  style={{
                                      backgroundColor: '#FFF', color: '#FFF', border: "none"
                                  }}
                                  expandIcon={(panelProps) => {
                                      if (panelProps.isActive) {
                                          return <MinusOutlined style={{fontSize: '24px', fontWeight: "900"}}/>
                                      } else {
                                          return <PlusOutlined style={{fontSize: '24px', fontWeight: "900"}}/>
                                      }
                                  }}
                        >
                            <Panel header="Specification"
                                   className={'help-center-collapse-copy'}
                                   key="1">
                                <div style={{paddingTop: '0.5rem'}}>
                                    <p
                                        style={{
                                            margin: '0 0 1.5rem 0',
                                            color: '#000',
                                            fontFamily: 'Proxima Nova bold, sans-serif',
                                            fontSize: windowWidth > 920 ? '2.1rem' : '1.6rem',
                                            lineHeight: 1.1
                                        }}
                                    >
                                        VT55WGV1
                                    </p>
                                    {specificationSections.map((section) => (
                                        <div key={section.title} style={{marginBottom: '2rem'}}>
                                            <p
                                                style={{
                                                    margin: '0 0 0.9rem 0',
                                                    color: '#000',
                                                    fontFamily: 'Proxima Nova Semibold, sans-serif',
                                                    fontSize: windowWidth > 920 ? '1.2rem' : '1.05rem',
                                                    lineHeight: 1.2
                                                }}
                                            >
                                                {section.title}
                                            </p>
                                            <div
                                                style={{
                                                    display: 'grid',
                                                    gridTemplateColumns: windowWidth > 1380
                                                        ? 'repeat(4, minmax(0, 1fr))'
                                                        : windowWidth > 760
                                                            ? 'repeat(2, minmax(0, 1fr))'
                                                            : '1fr',
                                                    gap: '0.75rem 1.5rem'
                                                }}
                                            >
                                                {section.items.map(([label, value]) => (
                                                    <div
                                                        key={`${section.title}-${label}`}
                                                        style={{
                                                            minWidth: 0
                                                        }}
                                                    >
                                                        <p
                                                            style={{
                                                                margin: 0,
                                                                color: '#000',
                                                                fontFamily: 'Proxima Nova Regular, sans-serif',
                                                                fontWeight: 700,
                                                                fontSize: '0.98rem',
                                                                lineHeight: 1.35
                                                            }}
                                                        >
                                                            {label}
                                                        </p>
                                                        <p
                                                            style={{
                                                                margin: '0.28rem 0 0 0',
                                                                color: '#333',
                                                                fontFamily: 'Proxima Nova Regular, sans-serif',
                                                                fontSize: '0.96rem',
                                                                lineHeight: 1.45
                                                            }}
                                                        >
                                                            {value}
                                                        </p>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </Panel>
                            <Panel header="Delivery" key="3" className={'help-center-collapse-copy'}>
                                <p>{PRODUCT_TEXT.Delivery}</p>
                            </Panel>
                            <Panel header="Return Policy" key="4" className={'help-center-collapse-copy'}>
                                <p>
                                    {PRODUCT_TEXT["Return Policy"]}
                                    <a href="mailto:info@vieunite.com"
                                       style={{color: "black", textDecoration: "underline"}}>
                                        support@vieunite.com.
                                    </a>
                                </p>
                            </Panel>
                            <Panel header="Downloads" key="6" className={'help-center-collapse-copy'}>
                                <a href="/Vieunite Pro - VT55WGV1 - Manual Version V1.0.pdf" target={'_blank'}>
                                    Vieunite Pro - VT55WGV1 - Manual Version V1.0 User Manual
                                </a>
                                <br></br>
                                <a href="/VT55WGV1 Technical Drawing.pdf">
                                    VT55WGV1 Technical Drawing
                                </a>
                            </Panel>
                            <Panel header="Warranty" key="7" className={'help-center-collapse-copy'}>
                                <p>{PRODUCT_TEXT.Warranty}</p>
                            </Panel>
                        </Collapse>
                    </Col>
                </Row>
                <ContactSection bgColor={'rgba(42, 150, 21, 0.08)'} link={"/pro/support/request-demo"}/>
            </Content>
        </Layout>
    )
}

export default ProCommodity;
